import React from "react"

export const ButtonParts = ({type, onClickEvent}) => {


    return (
        <div>
        {
            type === 'yes' && 
            <a className="btn1" 
                onClick={() => { onClickEvent() }}>はい</a>
        }
        {
            type === 'no' && 
            <a className="btn2"
                onClick={() => { onClickEvent() }}>いいえ</a>
        }
        {
            type === 'back' && 
            <a className="btn3"
                onClick={() => { onClickEvent() }}>もどる</a>
        }
        </div>
    )

}